import  { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './myBooks.css';
import writingsImg from '../assets/writings.png';
import book1Cover from '../assets/beforewegetolderCover.png';
import book2Cover from '../assets/theinbetweencover.jpg';

const myBooks = [
  {
    title: 'Before We Get Older',
    subtitle: 'The 20 Years Life Lessons',
    quote: ' In life, we face the experiences first and learn the lessons afterward.',
    description:
      'Lessons learned from the formative experiences (our teenage years). A reflection on the growth, challenges, and insights that shape us during those pivotal years — and how they continue to influence us as we grow older.',
    cover: book1Cover,
    link: '/before-we-get-older',
    tag: 'Life & Growth',
    chipColor: 'chip-yellow',
  },
  {
    title: 'The In-Between',
    subtitle: 'A Journey to Balance and Healing',
    quote: 'The In-Between is where you are, the best you will ever be.',
    description:
      'A  healing journey inward exploring the 4 pillars of inner balance - trauma, mind, soul, and body. A guide to understanding and nurturing the in-between moments of life, where healing and growth happen.',
    cover: book2Cover,
    link: '/the-in-between',
    tag: 'Healing & Balance',
    chipColor: 'chip-purple',
  },
];

function MyBooks() {
  const cardRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    cardRefs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="library-page">

      {/* HERO — untouched */}
      <section className="library-hero">
        <div className="journal-hero-text">
          <h1>Loubna's Writings</h1>
          <p>
            A collection of my books and long-form writing — <br />
            stories, reflections, and lessons shaped by growth and transition.
          </p>
        </div>
        <div className="journal-hero-img">
          <img src={writingsImg} alt="Writings illustration" />
        </div>
      </section>

      {/* BOOKS */}
      <section className="books-editorial">
        {myBooks.map((book, index) => (
          <article
            key={index}
            ref={(el) => (cardRefs.current[index] = el)}
            className={`editorial-book ${index % 2 !== 0 ? 'reverse' : ''} book-reveal`}
          >
            {/* Cover */}
            <div className="editorial-cover">
              <img src={book.cover} alt="" className="cover-blur-img" aria-hidden="true" />
              <img src={book.cover} alt={book.title} className="cover-main-img" />
            </div>

            {/* Text */}
            <div className="editorial-text">
              <span className={`book-chip ${book.chipColor}`}>{book.tag}</span>
              <h2>{book.title}</h2>
              <p className="editorial-subtitle">{book.subtitle}</p>
              <blockquote>"{book.quote}"</blockquote>
              <p className="editorial-description">{book.description}</p>
              <Link to={book.link} className="editorial-btn">
                Enter the Book
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </Link>
            </div>
          </article>
        ))}
      </section>

    </div>
  );
}

export default MyBooks;